const transitionList = async function(node, activeList) {
    for (let index = 0; index < activeList.length; index++) {
        const i = activeList[index];
        await node.transition(i.duration, i.easing)
            .attr(i.arrt);
    }
    return Promise.resolve();
}
export default transitionList;